import { Routes } from '@angular/router';

import { provideEffects } from '@ngrx/effects';
import { OfflineSelfRegistrationEffects } from 'landlord/main/+state/offline-self-registration/offline-self-registration.effects';
import { provideState } from '@ngrx/store';
import { offlineSelfRegistrationFeature } from 'landlord/main/+state/offline-self-registration/offline-self-registration.reducers';
import { SelfRegistrationGuard } from './guards/self-registration.guard';
import { DigitalContractLandingComponent } from './components';
import { OfflineSelfRegistrationComponent } from './components/offline-self-registration/offline-self-registration.component';
import {
  OfflineSelfRegistrationIntroComponent,
  OfflineSelfRegistrationWizardComponent
} from './components/offline-self-registration/components';

export const ROUTES: Routes = [
  {
    path: 'signContract',
    component: DigitalContractLandingComponent
  },
  {
    path: 'selfRegistration',
    component: OfflineSelfRegistrationComponent,
    canActivate: [SelfRegistrationGuard],
    providers: [
      provideState(offlineSelfRegistrationFeature),
      provideEffects(OfflineSelfRegistrationEffects)
    ],
    children: [
      {
        path: '',
        redirectTo: 'intro',
        pathMatch: 'full'
      },
      {
        path: 'intro',
        component: OfflineSelfRegistrationIntroComponent
      },
      {
        path: 'wizard',
        component: OfflineSelfRegistrationWizardComponent
      }
    ]
  }
];
